<script setup>
/** 商品包收入：横向单色柱，商品名在轴上；tooltip 里带订单数和到账积分。 */
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import EChart from '../EChart.vue'
import { categoryAxis, chartBase, chartTheme, valueAxis } from '../chart-theme.js'
import { useAdminTheme } from '../../composables/useAdminTheme.js'
import { formatCurrency } from '../../pages/billing/format.js'

const props = defineProps({
  items: { type: Array, required: true },
})

const emit = defineEmits(['select'])
const { t } = useI18n()
const { theme: themeName } = useAdminTheme()

// 收入高的排在最上面：横向柱的类目轴是自下而上画的。
const rows = computed(() => [...props.items].reverse())

const option = computed(() => {
  const theme = chartTheme(themeName.value)
  return {
    ...chartBase(theme),
    color: [theme.bar],
    grid: { top: 16, left: 16, right: 24, bottom: 12, containLabel: true },
    tooltip: {
      ...chartBase(theme).tooltip,
      formatter: params => {
        const row = rows.value[params[0].dataIndex]
        return [
          `<strong>${params[0].axisValue}</strong>`,
          `${t('visualGameAdmin.billing.dashboard.charts.revenue')}: ${formatCurrency(row.revenue_cents, 'usd')}`,
          `${t('visualGameAdmin.billing.dashboard.charts.paidOrders')}: ${row.orders}`,
          `${t('visualGameAdmin.billing.dashboard.charts.pointsGranted')}: ${row.points.toLocaleString('en-US')}`,
        ].join('<br>')
      },
    },
    xAxis: { ...valueAxis(theme), axisLabel: { color: theme.textMuted, formatter: value => formatCurrency(value, 'usd') } },
    yAxis: { ...categoryAxis(theme), data: rows.value.map(row => (row.title === null ? row.product_id : row.title)) },
    series: [{ type: 'bar', barMaxWidth: 22, data: rows.value.map(row => row.revenue_cents) }],
  }
})
</script>

<template>
  <EChart :option="option" height="320px" @select="emit('select', rows[$event.index])" />
</template>
